import { SelectChip } from "../../chips/select-chip/SelectChip";
import { PickerItem, TriggerProps } from "../types";

export function DefaultTrigger<T extends PickerItem>(props: TriggerProps<T>) {
  if (props.selectionMode === "single" && props.selectedItems[0]) {
    return (
      <SelectChip
        icon={props.icon}
        isSelected
        testID={props.testID}
        isDisabled={props.isDisabled}
      >
        {props.selectedItems[0].name}
      </SelectChip>
    );
  }

  return (
    <SelectChip
      icon={props.icon}
      badge={props.count}
      isSelected={props.count ? props.count > 0 : false}
      testID={props.testID}
      isDisabled={props.isDisabled}
    >
      {props.label}
    </SelectChip>
  );
}
